'use client';

import { createContext } from 'react';

import type { AvatarRootContextInterface } from '../types/avatar-root.types';

export const AvatarRootContext = createContext<AvatarRootContextInterface>({});

AvatarRootContext.displayName = 'Avatar.Root.Context';
